import React, { createContext, useState, useContext } from 'react';
import { getBasketList } from '../utils/api'

// ایجاد Context
const CartContext = createContext();

// هوک برای دسترسی به Context
export const useCart = () => useContext(CartContext);

// Provider برای مدیریت وضعیت سبد خرید
export const CartProvider = ({ children }) => {


    const [cartItems, setCartItems] = useState('');
    const [basketList, setBasketList] = useState('');

    const addToCart = async () => {
        let clientId = localStorage.getItem('clientId')
        try {
            let res = await getBasketList(clientId)
            if (res.data.isSuccess) {
                setCartItems(res.data.data.length); // اطمینان از مقداردهی صحیح
                setBasketList(res.data.data)
            }
        } catch (error) {

        }
        // const items = sessionStorage.getItem('cartItems');
        // if (items) {
        //     const parsedItems = JSON.parse(items);
        //     setCartItems(parsedItems.length); // اطمینان از مقداردهی صحیح
        // } else {
        //     setCartItems(0); // مقدار پیش‌فرض
        // }
    };


    return (
        <CartContext.Provider value={{ cartItems, addToCart,basketList }}>
            {children}
        </CartContext.Provider>
    );
};
